module.exports = require('./helpers/bundle-url').getBundleURL('gbl1F') + "logo-dark.eefe0b7f.svg";